import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { UserLegalInfo } from 'src/app/shared/enums/enums'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
@Component({
  selector: 'ddc-privacypolicy',
  templateUrl: './ddc-privacypolicy.component.html',
  styleUrls: ['./ddc-privacypolicy.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcTextGradientComponent],
})
export class DdcPrivacypolicyComponent {
  _lastUpdate: string = UserLegalInfo.LAST_UPDATED
  _text: string = UserLegalInfo.PRIVACY_POLICY
}
